/**
 * 홈(/) 진입 딥링크 분기 (CP1 D4 — 격리 우선 + 완료 후 재생)
 *
 * 격리 대상이면 창을 열지 않고 보관한다 — 허용 창(quests 등) 딥링크도 온보딩 흐름을
 * 건너뛰지 않게 일괄 보관하고, 재생은 온보딩 완료 직후 OnboardingGuide 가 한다.
 */
import { type DeepLink, type OnboardingGateUser, isOnboardingIsolated } from '@aegislab/shared';
import { useWindowStore } from '@/shared/model';
import { invalidateDeepLinkQueries } from '../deepLinkQueryInvalidation';
import { stashOnboardingDeepLink } from './deepLinkStash';

export function handleHomeDeepLink(
  user: (OnboardingGateUser & { id: string }) | null,
  deepLink: DeepLink
): void {
  if (user && isOnboardingIsolated(user)) {
    stashOnboardingDeepLink(user.id, deepLink);
    return;
  }
  // 푸시를 눌러 들어온 착지 — 창을 열기만 하면 전역 staleTime(5분) 안에서는 옛 화면이
  // 그대로 뜬다. 알림이 알린 변화가 보이도록 그 창의 좌표를 무효화한다.
  invalidateDeepLinkQueries(deepLink.view);
  useWindowStore.getState().openWindow(deepLink.view, deepLink.context);
}
